import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/abs/collaterals`, params });
